import { ENGINEERING_SYSTEMS_CDN_PATH } from '../../../engineering-systems-constants';
import { HeaderSectionStructure } from '../../../components/header-section/header-section-types';

export const SEWERAGE_HEADER_SECTION_CONFIG: HeaderSectionStructure = {
  title: 'Системы водоснабжения и\u00A0канализации',
  description:
    'Спроектируем и\u00A0установим систему водоснабжения любой сложности под ключ. Выполняем работы от\u00A0подбора насосной станции и\u00A0прокладки труб до\u00A0обустройства сантехнического шкафа и\u00A0подведения коммуникаций. Оформите заявку, а\u00A0мы\u00A0подберём решение, составим проект и\u00A0установим оборудование у\u00A0вас дома.',
  img: {
    src: `${ENGINEERING_SYSTEMS_CDN_PATH}/systems/sewerage.jpg/sewerage.jpg`,
    alt: 'Системы водоснабжения и канализации',
  },
  consultationSignupBtn: {
    elementBlock: 'landingSistemyVodosnabzheniya',
    label: 'Записаться на консультацию',
    elementText: 'Системы водоснабжения и канализации',
  },
};
